/* file description */

import SpComList from '@/components/sp-com-list';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import React from 'react';
import { RelationTreeType } from '../type';

interface UseFreeComponentsProps {
  relationSchema: RelationTreeType;
  index?: number;
  refList?: any;
}

export const useFreeComponents = ({ relationSchema, index, refList }: UseFreeComponentsProps) => {
  const positionModule = relationSchema?.code;
  const extralComponents = {};

  const sotreState = useMetaStore((state) => state);
  const { values, setValues, realoadValue, rulesMap, resetValue, setValuesImmediate } = useValuesStore();
  const { pageConfig } = sotreState;

  const freeComList = pageConfig?.freedomComponents?.filter((item) => item['position-module'] === positionModule);

  const onChange = (valueObject: Record<string, any> = {}) => {
    Object.keys(valueObject).forEach((key) => {
      // setValues(key, valueObject[key]);
      setValuesImmediate(v => {
        return {
          ...v,
          [key]: valueObject[key],
        };
      });
    });
    // 多次并发会出现问题
    // resetValue(valueObject);
  };

  (freeComList || []).forEach((com: any) => {
    extralComponents[com['position-direction']] = {
      title: com?.title || '',
      renderSchema: React.createElement(SpComList,
        {
          values,
          onChange,
          rulesMap,
          _rowId: '_id',
          _headId: '_headId',
          metaConfig: {
            freeComponentsConfig: com,
            relationSchema,
            index,
            reload: realoadValue,
            ...sotreState,
          },
          refList,
        }, null),
    };
  });

  return {
    extralComponents,
  };
};
